<template>
  <CustomModal id="cover-image-edit-modal"
               class="basic-modal cover-image-edit-modal"
               v-bind:ok-disabled="saveDisabled"
               v-bind:ok-busy="busy"
               v-bind:ok-title="$t('common.save')"
               v-on:cancel="$emit('cancel')"
               v-on:ok="save()">
    <div class="cover-image-edit-modal__title" slot="modal-header">
      {{ $t('publishers.modal.cover_image_edit.title') }}
    </div>

    <div class="text-center" v-if="loading">
      <LoadingBounce></LoadingBounce>
      <div class="typography--body-2 typography--color-disabled pb-5">
        {{ $t('common.loading') }}
      </div>
    </div>

    <div class="cover-image-edit-modal__form" v-else>
      <div class="cover-image-edit-modal__cover-img-thumb" v-bind:style="coverImageStyle"></div>

      <label class="cover-image-edit-modal__cover-img-input text-center clickable">
        <img src="/static/images/icon-camera.png" alt="">
        <input type="file" class="no-display" accept="image/png,image/jpeg,image/jpg" v-on:change="onCoverImageChange">
      </label>
    </div>

    <div class="typography--body-3 typography--color-secondary mt-16">
      {{ $t('publishers.modal.cover_image_edit.message') }}
    </div>
  </CustomModal>
</template>

<script>
  import { mapActions } from 'vuex';
  import { isNil } from 'lodash';

  export default {
    name: 'cover-image-edit-modal',

    props: {
      seriesItem: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        loading: false,
        coverImage: null,
        coverImageFile: null,
        acceptableFileTypes: [
          'image/jpg',
          'image/jpeg',
          'image/png',
        ],
        fileSizeLimit: 10 * 1024 * 1024,
        busy: false,
      };
    },

    computed: {
      coverImageStyle() {
        if (!isNil(this.coverImage)) {
          return {
            'background-image': `url('${this.coverImage}')`,
          };
        }

        return {};
      },

      saveDisabled() {
        if (!isNil(this.seriesItem)) {
          return this.coverImage === this.seriesItem.cover_image;
        }

        return true;
      },
    },

    methods: {
      ...mapActions([
        'uploadNewSeriesCoverImage',
      ]),

      onCoverImageChange() {
        const images = event.target.files || event.dataTransfer.files;

        if (!images.length) {
          return null;
        }

        const file = images[0];

        if (!file || file.size === undefined || file.type === undefined) {
          return null;
        }

        if (file.size > this.fileSizeLimit) {
          // alert file size
          return this.$root.$emit('show::modal', 'file-size-alert');
        }

        if (this.acceptableFileTypes.indexOf(file.type) === -1) {
          // alert wrong file type
          return this.$root.$emit('show::modal', 'file-type-alert');
        }

        return this.createMedia(file, 'image');
      },

      createMedia(file) {
        if (!window.FileReader) {
          return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
        }

        const reader = new window.FileReader();

        reader.onload = (event) => {
          this.coverImage = event.target.result;
          this.coverImageFile = file;
        };

        return reader.readAsDataURL(file);
      },

      save() {
        if (!this.busy) {
          this.busy = true;

          if (isNil(this.coverImageFile)) {
            return;
          }

          const params = {
            seriesId: this.seriesItem.id,
            imageFile: this.coverImageFile,
          };

          this.uploadNewSeriesCoverImage(params)
            .then(() => (
              this.$emit('ok')
            ));
        }
      },
    },

    beforeMount() {
      this.loading = true;

      if (!isNil(this.seriesItem)) {
        this.coverImage = this.seriesItem.cover_image;
      }

      this.loading = false;
    },
  };
</script>

<style lang="scss">
  .cover-image-edit-modal {
    .cover-image-edit-modal__form {
      position: relative;
    }

    .cover-image-edit-modal__cover-img-thumb {
      border-radius: 4px;
      height: 250px;
      background-color: #f7f7f7;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .cover-image-edit-modal__cover-img-input {
      border-radius: 4px;
      position: absolute;
      width: 100%;
      height: 250px;
      left: 0;
      top: 0;
      transition: background-color .5s ease;

      &:hover {
        background-color: rgba(0,0,0,.26);
        transition: background-color .5s ease;
      }

      img {
        margin-top: 75px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/CoverImageEditModal.vue